import _ from 'lodash';
import React, { useEffect } from 'react';
import styles from '../../styles/chart.module.scss';
import { appendExtraDataToUrl } from '../../utils/extra-data';
export const IFrameComponent = ({ elementId, customChartAppUrl, frameTitle, chartIframeElRef, onIFrameLoadCallback, onIFrameErrorCallback, extraData }) => {
    const customChartAppUrlWithExtraData = appendExtraDataToUrl(customChartAppUrl, extraData);
    return (React.createElement("iframe", { id: elementId, "data-testid": elementId, title: frameTitle, src: customChartAppUrlWithExtraData, name: "frame1", ref: (ref) => {
            chartIframeElRef.current = ref;
        }, onLoad: () => onIFrameLoadCallback(`#${elementId}`), onError: onIFrameErrorCallback, className: `${styles.chartIframe}` }));
};
export const MockIFrameComponent = ({ elementId, customChartAppUrl, chartIframeElRef, onIFrameLoadCallback, onIFrameErrorCallback, }) => {
    useEffect(() => {
        onIFrameLoadCallback(null);
    }, []);
    return (React.createElement("div", { ref: ref => {
            chartIframeElRef.current = {
                contentWindow: {
                    postMessage: _.noop,
                },
            };
        }, id: elementId, "data-testid": elementId }, customChartAppUrl));
};
//# sourceMappingURL=iframe.component.js.map